import * as _  from 'lodash'
import {UOM} from "../../PA.MD.Services/PA.MD.Services.IF";
import {PAdbContext} from "../PAdbContext";
import {Domain_getItems} from "../PAdbUtils";
import {ICellMetricUOM} from "../../PA.HyperRectangle.Core/PA.HyperRectangle.IF";


export interface UOMformatOptions {
    languageCd?: string,
    bUseCurrencySymbol?: boolean,
    bUseAbbreviation?: boolean,
    sNumDenomSeperator?: string
}

export interface UOMformat {
    CurrencyPrefix?: string,
    CurrencyPostfix?: string,
    AmountName?: string,
    UOMName?: string
}




export class UOMUtils {
    private static _bIsLoaded: boolean = false
    private static _onLoadPromise: Promise<void> = undefined
    private static _dctCurrency: {
        [currencyCd: string]: {
            currencyCd: string,
            symbol: string,
            symbolPostfixed: boolean,//EU
            abbreviation: string,
            abbreviationByLanguage: { [langCd: string]: string }
            name: string,
            nameByLanguage: { [langCd: string]: string }
        }
    } = {}

    private static _dctUOM: {
        [uomCd: string]: {
            uomCd: string,
            abbreviation: string,
            abbreviationByLanguage: { [langCd: string]: string }
            name: string,
            nameByLanguage: { [langCd: string]: string }
        }
    } = {}

    private static _dctAmountType: {
        [amountType: string]: {
            amountType: string,
            name: string,
            nameByLanguage: { [langCd: string]: string }
        }
    } = {}

    static get bIsLoaded(): boolean {
        return UOMUtils._bIsLoaded
    }

    static get OnLoadComplete(): Promise<void> {
        if (UOMUtils._bIsLoaded)
            return Promise.resolve()
        if (UOMUtils._onLoadPromise)
            return UOMUtils._onLoadPromise

        let rv = UOMUtils._onLoadPromise = (async () => {

            let dbContext = new PAdbContext()

            // In the future, this will come from a Currency Table
            let currencies = await Domain_getItems(dbContext, ['Currency'])
            _.forEach(currencies, (anItem) => {
                let id = anItem.cif.DOMAIN_ITEM_ID
                let name = anItem.cif.DOMAIN_ITEM_NAME

                if (!(id in UOMUtils._dctCurrency)) {
                    UOMUtils._dctCurrency[id] = {
                        currencyCd: id,
                        abbreviation: name,
                        abbreviationByLanguage: {},
                        name: name,
                        nameByLanguage: {},
                        symbol: "",
                        symbolPostfixed: true
                    }
                }
                let entry = UOMUtils._dctCurrency[id]
                entry.abbreviation = name
                entry.name = name

            }) // Next Currency

            // Read UOMs from Domains
            let uoms = await Domain_getItems(dbContext, ['UOM'])
            _.forEach(uoms, (anItem) => {
                let id = anItem.cif.DOMAIN_ITEM_ID
                let name = anItem.cif.DOMAIN_ITEM_NAME

                if (!(id in UOMUtils._dctUOM)) {
                    UOMUtils._dctUOM[id] = {
                        uomCd: id,
                        abbreviation: name,
                        abbreviationByLanguage: {},
                        name: name,
                        nameByLanguage: {}
                    }
                }
                let entry = UOMUtils._dctUOM[id]
                entry.abbreviation = name
                entry.name = name

            }) // Next Currency

            let amountTypes = await Domain_getItems(dbContext, ['UOMAmountType'])
            _.forEach(amountTypes, (anItem) => {
                let id = anItem.cif.DOMAIN_ITEM_ID
                let name = anItem.cif.DOMAIN_ITEM_NAME

                if (!(id in UOMUtils._dctAmountType)) {
                    UOMUtils._dctAmountType[id] = {
                        amountType: id,
                        name: name,
                        nameByLanguage: {}
                    }
                }
                let entry = UOMUtils._dctAmountType[id]
                entry.name = name

            })

            UOMUtils._bIsLoaded = true


        })();

        return rv
    }

    static getUOMFormat(uom: UOM, options?: UOMformatOptions): UOMformat {
        if (_.isEmpty(uom))
            return {}
        let opts = options || {}
        if (!UOMUtils.bIsLoaded)
            UOMUtils.OnLoadComplete

        let rv: UOMformat = {}
        if (uom.bCurrency) {
            if (uom.CurrencyCode in UOMUtils._dctCurrency) {
                let entry = UOMUtils._dctCurrency[uom.CurrencyCode]

                if (opts.bUseCurrencySymbol) {
                    if (entry.symbolPostfixed)
                        rv.CurrencyPostfix = entry.symbol
                    else
                        rv.CurrencyPrefix = entry.symbol
                } else {
                    rv.CurrencyPostfix = entry.abbreviation
                }

            } else {
                rv.CurrencyPostfix = "_"
            }
        }

        if (uom.bUOM) {
            if (uom.UOMCode in UOMUtils._dctUOM) {
                let entry = UOMUtils._dctUOM[uom.UOMCode]
                if (opts.bUseAbbreviation)
                    rv.UOMName = entry.abbreviation
                else
                    rv.UOMName = entry.name

            }
        }

        if (!_.isEmpty(uom.AmountType)) {
            if (uom.AmountType in UOMUtils._dctAmountType) {
                let entry = UOMUtils._dctAmountType[uom.AmountType]
                rv.AmountName = entry.name
            } else {
                rv.AmountName = "_"
            }
        }

        return rv
    }

    static getUOMText(uom: UOM, options?: UOMformatOptions): string {
        let fmt = UOMUtils.getUOMFormat(uom, options)
        if (_.isEmpty(fmt))
            return ""
        let rv: string[] = []
        if (fmt.AmountName)
            rv.push(fmt.AmountName)
        if (fmt.CurrencyPrefix)
            rv.push(fmt.CurrencyPrefix)
        if (fmt.CurrencyPostfix)
            rv.push(fmt.CurrencyPostfix)
        if (fmt.UOMName)
            rv.push(fmt.UOMName)

        return rv.join(" ")
    }

    static getMetricUOMText(metricUOM: ICellMetricUOM, options?: UOMformatOptions): string {

        if (_.isEmpty(metricUOM))
            return ""
        let opts = options || {}
        let numText= ""
        let denomText = ""
        if(metricUOM.NumeratorUOM?.bUOM || metricUOM.NumeratorUOM?.bCurrency){
            numText = UOMUtils.getUOMText(metricUOM.NumeratorUOM, opts)
        }
        if(metricUOM.DenominatorUOM?.bUOM || metricUOM.DenominatorUOM?.bCurrency) {
            denomText = UOMUtils.getUOMText(metricUOM.DenominatorUOM, opts)
        } else
            return numText

        let sep = opts.sNumDenomSeperator || "/"
        return [numText, sep, denomText].join(" ")
    }

}